/* eslint-disable no-use-before-define */
import axios from "axios";

import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import AddIcon from 'mdi-react/PlusCircleOutlineIcon';

const useStyles = makeStyles((theme) => ({
  root: {
	width: '100%',
	'& > * + *': {
	  marginTop: theme.spacing(3),
	},
  },
  fieldset : {
	'& .Mui-focused .MuiOutlinedInput-notchedOutline' : {
		borderColor:"#780F9E"
	},
	'& legend':{
		fontSize:16
	}
	
  },
  '.MuiIconButton-root' : {
	  padding:'12px'
  },
  
}));
const apiUrl = process.env.API_ROOT;

const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
}
const filterOptions = (options, { inputValue }) => { return options }

const defaultOptions = [
	"Construct a general summary in 300 words",
	"Write a listing description in an upbeat tone",
	"Write an email letting a potential buyer know about this property",
	"Write an email from a real estate broker to a home owner to discuss selling",
	"Create a social media post to highlight the amenities in 280 characters"
]

export default function CollectionTags({ tags, input, placeholder }) {
  const classes = useStyles();
  const [options, setOptions] = React.useState(defaultOptions);
  const [value, setValue] = React.useState('');
  const [inputValue, setInputValue] = React.useState('');
  React.useEffect(() => {
	
  
	  return () => {
		
	  };
  }, [value, inputValue]);
  return (
	<div className={classes.root}>
	  <Autocomplete
		
		limitTags={2}
		id="multiple-limit-tags"
		options={options}
		getOptionSelected={(option, value) => (value.group_tags ? value.group_tags : value) === (option.group_tags ? option.group_tags : option)}
		freeSolo
		onChange={(event, newValue) => {
		  console.log("onChange",newValue)
		  input.onChange(newValue);
		 // handleTagChange(newValue.map(option => option.group_tags ? option.group_tags : option ).filter(onlyUnique));
		}}
		
		onInputChange={(event, newInputValue) => {
		  console.log("onInputChange",newInputValue)
		  input.onChange(newInputValue);
		}}
		
		getOptionLabel={(option) => option.group_tags ? option.group_tags : option}
		defaultValue={tags}
		renderInput={(params) => (
		  <TextField {...params} 
		  	className={classes.fieldset}
			  onClick={(event) => {
			  event.stopPropagation();
			  }} 
			  variant="outlined" 
			label="" 
			placeholder={placeholder} />
		)}
		renderOption={(option) => {

			   return (
				  <div className="autocomplete-search">{option}</div>
				); 
	
			  
			
		  }}
	  />
	</div>
  );
}
